export default "__VITE_ASSET__18e84d23__"